const BASE_ENDPOINT = '/v3/vocabulary'
export const VocabularyEndpoints = {
  Collections: `${BASE_ENDPOINT}/collections`,
  Collection: ({ collectionId }: { collectionId: string }) =>
    `${BASE_ENDPOINT}/collections/${collectionId}`,
  Subscribe: ({ collectionId }: { collectionId: string }) =>
    `${BASE_ENDPOINT}/progress/${collectionId}`,
  ActiveCollections: `${BASE_ENDPOINT}/progress/active`,
  RateCollection: ({ collectionId }: { collectionId: string }) => `${BASE_ENDPOINT}/collections/${collectionId}/rating`,
  CollectionWords: (id: string) => `${BASE_ENDPOINT}/collections/${id}/words`,
  Word: (payload: { wordID: string; targetLanguageID: string }) =>
    `${BASE_ENDPOINT}/words/${payload.wordID}/${payload.targetLanguageID}`,
  Settings: BASE_ENDPOINT + '/settings',
  TodayProgress: ({ collectionId }: { collectionId: string }) =>
    BASE_ENDPOINT + `/progress/${collectionId}/today`,
  VocabularyProgress: BASE_ENDPOINT + `/progress`,
  ExtraProgress: ({ collectionId }: { collectionId: string }) =>
    BASE_ENDPOINT + `/progress/${collectionId}/extra`,
  RemoveActiveCollection: ({ collectionId }: { collectionId: string }) =>
    BASE_ENDPOINT + `/progress/${collectionId}`
} as const
